<template>
  <div v-for="element in content" :key="element.type">
    <UiHeading v-if="element.type === NodeType.HEADING" :type="getHeadingType(element.level)" class="my-2">
      {{ element.children.map((c) => (c.type === NodeType.TEXT ? c.text : c.url)).join('\n') }}
    </UiHeading>
    <div v-else-if="element.type === NodeType.PARAGRAPH" class="mb-6 mt-2">
      <UiRichTextContentParagraph :children="element.children" />
    </div>
    <div v-else-if="element.type === NodeType.LIST" class="mb-6 mt-2">
      <UiRichTextContentList :children="element.children" :format="element.format" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RichTextContentProps } from '~/components/ui/RichTextContent/types';

import { NodeType } from '~/stores/cms/types';

const getHeadingType = (level: 1 | 2 | 3 | 4 | 5 | 6): 'h1' | 'h2' | 'h3' => {
  switch (level) {
    case 1:
      return 'h1';
    case 2:
      return 'h2';
    default:
      return 'h3';
  }
};

defineProps<RichTextContentProps>();
</script>
